/**
 * Directory empty state must not render while a geo/search wait is still
 * in flight. InstantSearch starts with empty hits; IP hydrate on
 * `/coaches/search` can also leave the first result set empty until the
 * visitor city is pinned.
 *
 * SSR `aroundLatLngViaIP` is the host, not the visitor. Keep skeletons
 * while `isLocationHydrating` even if that host query returned hits, so
 * marketplace cards do not first-paint the wrong geo. After a visitor
 * pin, later searches keep cards on screen (`hitCount > 0`).
 *
 * InstantSearch keeps the last `error` until a later search succeeds, so
 * a retry (`searching` / `isSearchStalled`) still counts as a wait. Only
 * treat `error` as settled when nothing is in flight.
 */
export function shouldShowDirectoryResultsLoader({
  hitCount = 0,
  savedOnlyEmpty = false,
  isLocationHydrating = false,
  searching = false,
  isSearchStalled = false,
  searchResults,
  error,
  thisWeekJoinPending = false,
} = {}) {
  if (savedOnlyEmpty) return false
  if (isLocationHydrating) return true
  if (hitCount > 0) return false
  if (searching || isSearchStalled || thisWeekJoinPending) return true
  if (error) return false
  return !searchResults || Boolean(searchResults.__isArtificial)
}
